import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import { TabsContext } from '../../../packages/kiti/components/tabs/TabsContext'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import PlaceLoader from './_load/PlaceLoader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TabsContent from '../../../packages/kiti/components/tabs/TabsContent'
import LocksContent from './tabs/locks/Locks'
import Qrcodes from './tabs/Qrcodes'
import Details from './tabs/Details'
import Assets from './tabs/assets/Assets'

import { useIsOwner, useSessionPermission } from '@btime/react-session'

const ShowPlaceModal = props => {
  const isOwner = useIsOwner()
  const shouldShowQRCodeTab = useSessionPermission('showQRCodeOnModalDetails')

  const tabsOptions = [
    { name: 'Detalhes', render: () => <Details /> },
    { name: 'Bloqueios', render: () => <LocksContent />, notShow: !isOwner },
    { name: 'QR Codes', render: () => <Qrcodes />, notShow: !shouldShowQRCodeTab },
    { name: 'Ativos', render: () => <Assets /> }
  ]

  return (
    <ControlledModal width="80rem" {...props}>
      <PlaceLoader>
        <TabsContext options={tabsOptions}>
          <ModalHeader />

          <HorizontalLine thin lineColor={COLORS.light2} />
          <Separator weight={4} />

          <TabsContent />
        </TabsContext>
      </PlaceLoader>
    </ControlledModal>
  )
}

export default ShowPlaceModal
